import TextField from '@mui/material/TextField';
import React from 'react';
import { PatternFormat } from 'react-number-format';

interface Props {
  readonly id?: string;
  readonly label?: string;
  readonly name?: string;
  readonly value?: unknown;
  readonly defaultValue?: unknown;
}

export const CNPJFormFieldInput: React.FC<Props> = (props: Props): React.ReactElement => {
  const { id, label, name, value } = props;

  if (value !== undefined) {
    throw new Error('CNPJFieldInput can only be uncontrolled');
  }

  const defaultValue = React.useMemo((): string => {
    if (props.defaultValue === null) {
      return '';
    }

    return String(props.defaultValue);
  }, [props.defaultValue]);

  return (
    <PatternFormat
      id={id}
      label={label}
      name={name}
      defaultValue={defaultValue}
      format="##.###.###/####-##"
      customInput={TextField}
      mask=""
    />
  );
};
